import type { LetterLangue } from '../types';

/**
 * Date d'en-tête de la lettre, dans la typographie de la langue où elle est écrite.
 *
 * La règle de format français vise les dates d'EXPÉRIENCE du CV, où l'homogénéité compte pour les
 * ATS. La date d'en-tête d'une lettre relève, elle, de la typographie de la langue de rédaction :
 * une lettre entièrement en anglais datée « 4 août 2026 » se lit comme un défaut, pas comme une
 * convention.
 *
 * Anglais en `en-GB` et non `en-US` : l'ordre jour-mois-année reste celui du bloc d'adresse
 * français qui l'entoure, là où « August 4, 2026 » introduirait une convention américaine dans une
 * lettre destinée à un recruteur français.
 *
 * `now` est injectable pour les tests — la date du jour est fournie par l'application, jamais
 * devinée par le modèle.
 */
export function letterDateDuJour(langue: LetterLangue, now: Date = new Date()): string {
  const locale = langue === 'anglais' ? 'en-GB' : 'fr-FR';
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(now);
}
